
















































import _ from 'lodash'
import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { OpenGraph, OpenGraphArticle, MetadataTranslation } from '@/modules/seo/types'
import ProfileEditor from '@/modules/seo/components/opengraph/ProfileEditor.vue'
import { Getter, Mutation } from 'vuex-class'
import DatePickerField from '@/components/DatePickerField.vue'

/**
 * Editor de atributos de un artículo OpenGraph
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
  components: {
    'profile-editor': ProfileEditor,
    'date-picker': DatePickerField,
  },
})
export default class ArticleEditor extends Vue {
  @Prop() public value: OpenGraph

  @Prop({type: Boolean, default: false})
  public disabled: boolean

  @Mutation('seo/metadata/current/translation/field/update')
  public updateCurrentTranslationField: (payload: { field: string; value: any }) => void

  @Getter('seo/metadata/current/translation') public translation: MetadataTranslation

  get article (): OpenGraphArticle {
    return this.translation.opengraph.article
  }

  /**
   * Actualiza un campo del artículo OpenGraph
   */
  public update (field: string, value: any) {
    this.updateCurrentTranslationField({ field: `opengraph.article.${field}`, value })
  }

  public creationTimeDatepickerModal = false
  public creationDate = null
}
